const dataName = 'coupon'
export default dataName